import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DASHBOARD_MAP_SWITCHER_OPTIONS } from '../constants'
import { changeDashboardType } from '../actions'
import { makeStyles } from '@material-ui/core'
// import { updateDashboardPreference } from '../../dashboard/api/dashboard-api'
import { enqueueSnackbar } from '../actions'

export default function DashboardMapSwitcher() {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)
    const { dashboardType } = useSelector(state => state.main)
    const dispatch = useDispatch()

    const handleDashboardTypeChange = async option => {
        try {
            // await updateDashboardPreference(option)
            dispatch(changeDashboardType(option))
        } catch (error) {
            dispatch(
                enqueueSnackbar({
                    message: locale.dashboard.defaultViewUpdateFail,
                    options: {
                        variant: 'warning'
                    }
                })
            )
        }
    }

    const configuredOptions = useMemo(() => {
        return Object.keys(DASHBOARD_MAP_SWITCHER_OPTIONS)
    })

    const DashboardSwitcherIcon = ({ option }) => {
        const Icon = DASHBOARD_MAP_SWITCHER_OPTIONS[option]?.icon

        return <Icon size={18} />
    }

    return (
        <div className={classes.wrapper}>
            {configuredOptions?.map((option, index) => {
                return (
                    <div
                        key={option}
                        onClick={() => handleDashboardTypeChange(option)}
                        className={`
                            ${classes.option} 
                            ${dashboardType === option ? classes.selected : ''}
                            ${index === 0 ? classes.first : ''}
                            ${
                                index + 1 === configuredOptions.length
                                    ? classes.last
                                    : ''
                            }
                        `}
                    >
                        <DashboardSwitcherIcon option={option} />
                    </div>
                )
            })}
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'flex',
        border: '3px',
        borderRadius: theme.borderRadius,
        backgroundColor: theme.grayLight,
        gap: '2px',
        padding: '4px'
    },
    option: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '5px 5px',
        minWidth: '40px',
        cursor: 'pointer'
    },
    selected: {
        backgroundColor: 'white'
    },
    first: {
        borderRadius: `${theme.borderRadius}px 0px 0px ${theme.borderRadius}px`
    },
    last: {
        borderRadius: `0px ${theme.borderRadius}px ${theme.borderRadius}px 0px`
    }
}))
